module.exports = __webpack_public_path__ + "static/media/car3d.dc376e73.png";